import { BASE_API_URL } from '@env';
import { useQuery } from 'react-query';
import { useUserStore } from '~providers/userStore/zustand';
import { GetUserSubcategoriesResponse } from '~types/api/user';

export function useGetUserSubcategories(user_id: string) {
  return useQuery<GetUserSubcategoriesResponse, Error>(['userSubcategories', user_id], async () => {
    const token = useUserStore.getState().token;
    const response = await fetch(`${BASE_API_URL}users/${user_id}/subcategories`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    if (!response.ok) {
      throw new Error('Failed to fetch user subcategories');
    }

    const data = await response.json();

    return data as GetUserSubcategoriesResponse;
  });
}
